(function(angular){
	'use strict';

	angular
		.module('apiModule')
		.factory('SettingsFactory', [
			'$q',
			'HTTP_STATUS',
			'INVESTMENT_ENTITY_ID',
			'urlFactory',
			settingsFactoryFunction
		]);

	function settingsFactoryFunction(
		$q,
		HTTP_STATUS,
		INVESTMENT_ENTITY_ID,
		urlFactory
	) {
		var factory = {
			dripPreference: {
				get: getDripPreference,
				set: updateDripPreference
			},
			password: {
				update: changeUserPassword
			},
			securityQuestions: {
				get: getFundriseSecurityQuestions,
				set: updateSecurityQuestions
			},
			emailUpdate: {
				set: updateEmail
			},
			accreditation: {
				update: updateAccreditationInformation
			},
			beneficiary: {
				getAll: getBeneficiaries,
				get: getBeneficiary,
				delete: deleteBeneficiary,
				post: postBeneficiary,
				update: updateBeneficiary
			},
			recurringInvestment: {
				get: getActiveRecurringInvestmentSchedule,
				validateDetails: validateRecurringInvestmentScheduleDetails,
				set: saveRecurringInvestmentSchedule,
				update: updateRecurringInvestmentSchedule,
				delete: deleteRecurringInvestmentSchedule,
				getAgreements: getRecurringInvestmentAgreements

			},
			knownLoginDevices: {
				delete: deleteKnownLoginDevice,
				get: getKnownLoginDevices,
				getDeviceDetail: getDeviceDetail
			}
		};

		function changeUserPassword(form, currentPassword, newPassword) {
			var url = '/api-secured/user/password';
			var payload = {
				currentPassword: currentPassword, 
				newPassword:newPassword
			};

			return urlFactory.apiPostPromise(url, payload)
				.catch(function(response) {
					urlFactory.handleServerValidation(form, response);
					return $q.reject();
				});
		}

		var dripUrl = "/api-secured/investment-entity/" + INVESTMENT_ENTITY_ID + "/drip-preference";

		function getDripPreference() {
			return urlFactory.apiGetPromise(dripUrl)
				.then(function(response) {
					if(response.data.reinvestmentPreference !== "RIA_REINVESTMENT") {
						return "CASH_DISTRIBUTION";
					}
					return "RIA_REINVESTMENT";
				})
				.catch(function(response) {
					urlFactory.handleFailedRequest(response);
				});
		}

		function updateDripPreference(form, reinvestmentPreference) {
			var payload = {
				reinvestmentPreference : reinvestmentPreference,
				originFeature : 'RIA DRIP Settings Page'
			};

			return urlFactory.apiPostPromise(dripUrl, payload)
				.catch(function(response) {
					urlFactory.handleServerValidation(form, response);
					return $q.reject();
				});
		}

		function getFundriseSecurityQuestions() {
			return urlFactory.apiGetPromise("/api/security-questions")
				.then(function(response) {
					return response.data;
				})
				.catch(function(response) {
					urlFactory.handleFailedRequest(response);
				});
		}

		function updateEmail(payload,form) {
			return urlFactory.apiPostPromise("/api-secured/user/email", payload)
				.catch(function(response) {
					urlFactory.handleServerValidation(form, response);
					return $q.reject();
				});
		}

		function updateSecurityQuestions(payload, form) {
			return urlFactory.apiPostPromise("/api-secured/user/security-questions", payload)
				.catch(function(response) {
					urlFactory.handleServerValidation(form, response);
					return $q.reject();
				});
		}

		function updateAccreditationInformation(data) {
			var url = "/api-secured/investment-entity/" + INVESTMENT_ENTITY_ID + "/accreditation/update";
			return urlFactory.apiPostPromise(url, data)
				.then(function(response) {
					return response.data;
				})
				.catch(function() {
					return $q.reject();
				});
		}

		function getBeneficiaries() {
			return urlFactory.apiGetPromise("/api-secured/investment-entity/" + INVESTMENT_ENTITY_ID + "/beneficiaries")
				.then(function(response) {
					return response.data;
				})
				.catch(function(response) {
					urlFactory.handleFailedRequest(response);
				});
		}

		function getBeneficiary(beneficiaryId) {
			return urlFactory.apiGetPromise("/api-secured/investment-entity/" + INVESTMENT_ENTITY_ID + "/beneficiary/" + beneficiaryId)
				.then(function(response) {
					return response.data;
				})
				.catch(function(response) {
					urlFactory.handleFailedRequest(response);
				});
		}

		function deleteBeneficiary(beneficiaryId) {
			return urlFactory.apiDeletePromise("/api-secured/investment-entity/" + INVESTMENT_ENTITY_ID + "/beneficiary/" + beneficiaryId)
				.catch(function(response) {
					urlFactory.handleFailedRequest(response);
				});
		}

		function postBeneficiary(form, data) {
			return urlFactory.apiPostPromise("/api-secured/investment-entity/" + INVESTMENT_ENTITY_ID + "/beneficiary", data)
				.catch(function(response) {
					urlFactory.handleServerValidation(form, response);
					return $q.reject();
				});
		}

		function updateBeneficiary(form, data, beneficiaryId) {
			return urlFactory.apiPutPromise("/api-secured/investment-entity/" + INVESTMENT_ENTITY_ID + "/beneficiary/" + beneficiaryId, data)
				.catch(function(response) {
					urlFactory.handleServerValidation(form, response);
					return $q.reject();
				});
		}

		function getActiveRecurringInvestmentSchedule() {
			return urlFactory.apiGetPromise('/api-secured/investment-entity/' + INVESTMENT_ENTITY_ID + '/recurring-investment')
				.then(function(response) {
					return response.data;
				})
				.catch(function(response) {
					if(response.status === HTTP_STATUS.NOT_FOUND) {
						return $q.resolve(undefined);
					}
					urlFactory.handleFailedRequest(response);
					return $q.reject();
				});
		}

		function validateRecurringInvestmentScheduleDetails(payload, form) {
			var validateRecurringInvestmentScheduleDetailsUrl = "/api-secured/investment-entity/" + INVESTMENT_ENTITY_ID + "/validate-recurring-investment";
			return urlFactory.apiPostPromise(validateRecurringInvestmentScheduleDetailsUrl, payload)
				.catch(function(response) {
					urlFactory.handleServerValidation(form, response);
					return $q.reject();
				});
		}

		function getRecurringInvestmentAgreements() {
			var recurringInvestmentScheduleAcknowledgementsUrl = '/api-secured/recurring-investment/acknowledgements';
			return urlFactory.apiGetPromise(recurringInvestmentScheduleAcknowledgementsUrl)
				.then(function(response) {
					angular.forEach(response.data, function(text, ack) {
						response.data[ack] = text.replace('fundrise.com/oc', '<a href="https://fundrise.com/oc" target="_blank">fundrise.com/oc</a>');
					});
					return response.data;
				})
				.catch(function() {
					return $q.reject();
				});
		}

		function saveRecurringInvestmentSchedule(payload) {
			var submitRecurringInvestmentScheduleUrl = "/api-secured/investment-entity/" + INVESTMENT_ENTITY_ID + "/recurring-investment";
			return urlFactory.apiPostPromise(submitRecurringInvestmentScheduleUrl, payload)
				.catch(function(response) {
					urlFactory.handleFailedRequest(response);
					return $q.reject();
				});
		}

		function updateRecurringInvestmentSchedule(payload) {
			var submitRecurringInvestmentScheduleUrl = '/api-secured/investment-entity/' + INVESTMENT_ENTITY_ID + '/recurring-investment';
			return urlFactory.apiPutPromise(submitRecurringInvestmentScheduleUrl, payload)
				.then(function(response) {
					var successUrl = '/account/investment-accounts/' + INVESTMENT_ENTITY_ID + '/individual-account/recurring-investment-settings/update/success';
					return successUrl;
				})
				.catch(function(response) {
					urlFactory.handleFailedRequest(response);
					return $q.reject();
				});
		}

		function deleteRecurringInvestmentSchedule() {
			var submitRecurringInvestmentScheduleUrl = '/api-secured/investment-entity/' + INVESTMENT_ENTITY_ID + '/recurring-investment';
			return urlFactory.apiDeletePromise(submitRecurringInvestmentScheduleUrl)
				.then(function(response) {
					var successUrl = '/account/investment-accounts/' + INVESTMENT_ENTITY_ID + '/individual-account/recurring-investment-settings/delete/success';
					return successUrl;
				})
				.catch(function(response) {
					urlFactory.handleFailedRequest(response);
					return $q.reject();
				});
		}

		function deleteKnownLoginDevice(deviceId) {
			var deleteKnownLoginDeviceUrl = '/api-secured/user/known-device/' + deviceId;
			return urlFactory.apiDeletePromise(deleteKnownLoginDeviceUrl)
				.catch(function(response) {
					urlFactory.handleFailedRequest(response);
					return $q.reject();
				});
		}

		function getDeviceDetail(deviceId) {
			return urlFactory.apiGetPromise("/api-secured/user/known-device/" + deviceId)
				.then(function(response) {
					return response.data;
				})
				.catch(function(response) {
					urlFactory.handleFailedRequest(response);
					return $q.reject();
				});
		}

		function getKnownLoginDevices() {
			return urlFactory.apiGetPromise("/api-secured/user/known-devices")
				.then(function(response) {
					var devices = response.data.knownDevices;
					var currentDeviceId = response.data.currentDeviceId;
					devices.forEach(function (device) {
						if (device.deviceId === currentDeviceId) {
							device.currentSession = true;
						}
					});

					return devices;
				})
				.catch(function(response) {
					urlFactory.handleFailedRequest(response);
					return $q.reject();
				});
		}

		return factory;
	}
})(window.angular);